<template>
  <div>
    <div class="admininOut" v-if="isLimit">
      <div class="form_item">
        <p class="label_item">设备编号：</p>
        <div class="codeNum">
          <input type="tel" placeholder="请输入或扫码填写设备编号" maxlength="10" v-model="barCode" />
          <img src="@/assets/images/scan.png" alt="" class="scanIMG" @click="scanCode" />
        </div>
      </div>
      <p class="error_text" ref="barCode">请填写设备编号</p>
      <div class="form_item">
        <p class="label_item">设备信息：</p>
        <dl>{{ machshineInfoTr }}</dl>
      </div>
      <p ref="machshine" class="error_text">请填写正确的设备编号</p>
      <div class="form_item flex_item">
        <span class="label_item_inline">领用类型：</span>
        <div class="flex-right-input" @click="showPickerType = true" ref="type">
          <input type="text" placeholder="请选择" readonly v-model="typeName" />
          <van-icon name="arrow-down" ref="sourcePlace" />
        </div>
      </div>
      <p class="error_text" ref="type">请选择领用类型</p>

      <div class="form_item flex_item">
        <span class="label_item_inline">校区：</span>
        <div class="flex-right-input" @click="openCityList" ref="cityName">
          <input type="text" placeholder="请选择" readonly v-model="cityName" />
          <van-icon name="arrow-down" ref="sourcePlace" />
        </div>
      </div>
      <p class="error_text" ref="cityName">请选择校区</p>
      <div class="form_item flex_item" v-show="this.ruleForm.type !== '2'">
        <span class="label_item_inline">在用者：</span>
        <div class="flex-right-input" @click="openWorker">
          <input type="text" placeholder="请选择" readonly v-model="ruleForm.currentWorker" />
          <van-icon name="arrow-down" ref="sourcePlace" />
        </div>
      </div>
      <p class="error_text" ref="currentName">请填写在用者</p>
      <div class="form_item flex_item" v-show="this.ruleForm.type !== '2'">
        <span class="label_item_inline">工号/身份证：</span>
        <div class="flex-right-input">
          <input type="text" readonly v-model="ruleForm.idCard" style="background-color: #e6e6e6" />
        </div>
      </div>
      <div v-show="this.ruleForm.type === '2'">
        <div class="form_item flex_item">
          <span class="label_item_inline">在用教室：</span>
          <div class="flex-right-input" @click="showPickerRoom = true">
            <input type="text" placeholder="请选择" readonly v-model="ruleForm.classRoom" />
            <van-icon name="arrow-down" ref="sourcePlace" />
          </div>
        </div>
        <p class="error_text" ref="currentRoom">请选择再用教室</p>
        <div class="form_item flex_item">
          <span class="label_item_inline">在用学生：</span>
          <div class="flex-right-input" @click="showPickerStudent = true">
            <input type="text" placeholder="请选择" readonly v-model="currentStudent" />
            <van-icon name="arrow-down" />
          </div>
        </div>
        <p class="error_text" ref="student">请填写在用学生</p>
      </div>
      <div class="form_item">
        <p class="label_item">备注：</p>
        <div class="textarea_remark">
          <textarea v-model="ruleForm.remark" placeholder="其他说明可在这里备注" rows="4"></textarea>
        </div>
      </div>
      <!--    按钮-->
      <div class="button_group">
        <van-button class="backBtn" @click="backToPre">返回</van-button>
        <van-button @click="submitOut">确认出库</van-button>
      </div>

      <!--校区下拉-->
      <van-popup v-model="showPickerCityname" round position="bottom">
        <van-picker show-toolbar :columns="allCityList" @confirm="onConfirmCity" class="selectGroup" @cancel="showPickerCityname = false">
          <template #option="option">
            <span>{{ option.name }}</span>
          </template>
        </van-picker>
      </van-popup>

      <!--在用者下拉-->
      <van-popup v-model="showPickerWorker" round position="bottom">
        <div class="select_border">
          <header>
            <span @click="emptySelect">清空</span>
            <span @click="onConfirmWorker">完成</span>
          </header>
          <div class="flex-center margin-bot">
            <van-search class="flex1" v-model="keywordsWorker" placeholder="搜索" @clear="searchWorker" />
            <span class="search-text" @click="searchWorker">搜索</span>
          </div>
          <van-radio-group v-model="ruleForm.worker" class="specialRadio">
            <van-cell-group>
              <van-cell v-for="item in currentWorkerList" :key="item.id" clickable @click="ruleForm.worker = JSON.stringify(item)">
                <template #title>
                  <div class="flex-user">
                    <span>{{ item.realname + "-QF" + item.jobNo }}</span>
                  </div>
                </template>
                <template #right-icon>
                  <van-radio :name="JSON.stringify(item)" />
                </template>
              </van-cell>
              <!--          </lazy-component>-->
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-popup>

      <!--校区下教室下拉-->
      <van-popup v-model="showPickerRoom" round position="bottom">
        <div class="select_border">
          <header>
            <span @click="emptySelect">清空</span>
            <span @click="onConfirmRooms">完成</span>
          </header>
          <div class="flex-center margin-bot">
            <van-search class="flex1" v-model="keywordsRoom" placeholder="搜索" @clear="searchRoom" />
            <span class="search-text" @click="searchRoom">搜索</span>
          </div>
          <van-radio-group v-model="currentRoom" class="specialRadio">
            <van-cell-group>
              <van-cell v-for="item in cityNameRooms" :key="item.id" clickable @click="currentRoom = JSON.stringify(item)">
                <template #title>
                  <div class="flex-user">
                    <span>{{ item.name }}</span>
                  </div>
                </template>
                <template #right-icon>
                  <van-radio :name="JSON.stringify(item)" />
                </template>
              </van-cell>
              <!--          </lazy-component>-->
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-popup>

      <!--教室下学生下拉-->
      <van-popup v-model="showPickerStudent" round position="bottom">
        <div class="select_border">
          <header>
            <span @click="emptySelect">清空</span>
            <span @click="onConfirmStudent">完成</span>
          </header>
          <div class="flex-center margin-bot">
            <van-search class="flex1" v-model="keywordsWorker" placeholder="搜索" @clear="searchStudent" />
            <span class="search-text" @click="searchStudent">搜索</span>
          </div>
          <van-radio-group v-model="studentName" class="specialRadio">
            <van-cell-group>
              <van-cell v-for="item in roomStudentList" :key="item.stuid" clickable @click="studentName = JSON.stringify(item)">
                <template #title>
                  <div class="flex-user">
                    <span>{{ item.stuname }}</span>
                  </div>
                </template>
                <template #right-icon>
                  <van-radio :name="JSON.stringify(item)" />
                </template>
              </van-cell>
              <!--          </lazy-component>-->
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-popup>

      <!--类型-->
      <van-popup v-model="showPickerType" round position="bottom">
        <van-picker show-toolbar :columns="typeList" @confirm="onConfirmType" class="selectGroup" @cancel="showPickerType = false">
          <template #option="option">
            <span>{{ option.name }}</span>
          </template>
        </van-picker>
      </van-popup>
    </div>
    <emptyPage :isLimit="isLimit" />
  </div>
</template>

<script>
import { weoauserCityList, assetsOut, machshineInfo, getAssetsWorker, getAssetsRoom, roomStudent } from "@/server/api";
import { Toast } from "vant";
import { wxConfig } from "@/views/fastReply/js/config";
import { pageLimit } from "@/utils/public";
import emptyPage from "@/components/emptyPage";

export default {
  name: "assetsOut",
  data() {
    return {
      ruleForm: {
        currentWorker: "", //input显示
        worker: "", //选中显示
        workerId: "",
        type: "",
        // cityId:'1',
        cityId: JSON.parse(localStorage.getItem("userInfo")).zsCityId + "", //当前登录者所属校区ID,
        idCard: "",
        remark: "",
        classRoomId: "",
        studentId: "",
        classRoom: "",
      },
      typeList: [
        {
          name: "个人",
          type: "1",
        },
        {
          name: "教室",
          type: "2",
        },
      ],
      barCode: "", //条形码编号
      cityName: "",
      typeName: "",
      studentName: "",
      currentStudent: "",
      currentRoom: "",
      keywordsWorker: "", //关键词搜索员工
      keywordsRoom: "", //关键词教室
      keywordsStudent: "", //关键词学生
      machshineInfoTr: "", //设备信息
      workerName: "", //使用员工
      student: "", //使用学生姓名
      allCityList: [], //校区列表
      showPickerCityname: false,
      showPickerWorker: false,
      showPickerType: false, //类型
      showPickerRoom: false,
      showPickerStudent: false,
      currentWorkerList: [], //员工
      remarkWorkerList: [], //备注员工
      cityNameRooms: [], //校区下教室
      remarkCityRooms: [], //备用教室列表
      roomStudentList: [], //在用学生
      remarkStudentList: [], //备用学生
      isLimit: "",
    };
  },
  components: { emptyPage },
  async created() {
    let that = this;
    await pageLimit("assents:add", function (bool) {
      that.isLimit = bool;
    });
    if (this.isLimit) {
      const { data: resData } = await weoauserCityList();
      if (resData.code !== 200) return Toast.fail(resData.msg);
      this.allCityList = resData.data;
      this.allCityList.map((item, index) => {
        if (item.id === this.ruleForm.cityId) {
          this.cityName = item.name;
          this.currentIndex = index;
        }
      });
      this.replyConfig();
    }
  },
  watch: {
    async barCode(val) {
      if (val.length === 10) {
        const { data: res } = await machshineInfo({ assetsNo: val });
        if (res.code !== 200) return Toast.fail(res.msg);
        let info = res.data;
        this.machshineInfoTr = `${info.name}-${info.brand}-${info.model}`;
      }
      this.$refs.barCode.style.display = "none";
    },
    async "ruleForm.type"(val) {
      if (val === "2") {
        const { data: resData } = await getAssetsRoom({
          cityId: this.ruleForm.cityId,
        });
        if (resData.code !== 200) return Toast.fail(resData.msg);
        this.remarkCityRooms = this.cityNameRooms = resData.data;
      } else {
        await this.getRequestCurrent();
      }
      this.$refs.type.style.display = "none";
    },
    async "ruleForm.cityId"(val) {
      if (this.ruleForm.type === "2") {
        const { data: resData } = await getAssetsRoom({
          cityId: val,
        });
        if (resData.code !== 200) return Toast.fail(resData.msg);
        this.cityNameRooms = resData.data;
      } else {
        await this.getRequestCurrent();
      }
    },
  },
  methods: {
    //搜索员工
    searchWorker() {
      if (!this.keywordsWorker) return (this.currentWorkerList = this.remarkWorkerList);
      this.currentWorkerList = this.remarkWorkerList.filter((item) => {
        return item.realname.indexOf(this.keywordsWorker) !== -1;
      });
    },

    //搜索学生
    searchStudent() {
      if (!this.keywordsStudent) return (this.roomStudentList = this.remarkStudentList);
      this.roomStudentList = this.remarkStudentList.filter((item) => {
        return item.stuname.indexOf(this.keywordsStudent) !== -1;
      });
    },

    //搜索学生
    searchRoom() {
      if (!this.keywordsRoom) return (this.cityNameRooms = this.remarkCityRooms);
      this.cityNameRooms = this.remarkCityRooms.filter((item) => {
        return item.name.indexOf(this.keywordsRoom) !== -1;
      });
    },
    //清空选择
    emptySelect() {
      if (this.showPickerWorker) {
        this.ruleForm.worker = "";
      } else if (this.showPickerRoom) {
        this.currentRoom = "";
      } else if (this.showPickerStudent) {
        this.studentName = "";
      }
    },

    // 打开校区
    openCityList() {
      this.showPickerCityname = true;
    },
    openWorker() {
      if (this.ruleForm.type === "1") {
        this.showPickerWorker = true;
      } else {
        this.$refs.type.style.display = "block";
      }
    },
    //校区下在用者
    async getRequestCurrent() {
      const { data: resData } = await getAssetsWorker({
        cityId: this.ruleForm.cityId,
      });
      if (resData.code !== 200) return Toast.fail(resData.msg);
      this.remarkWorkerList = this.currentWorkerList = resData.data;
    },
    //选择校区确认
    onConfirmCity(val) {
      this.ruleForm.cityId = val.id;
      this.cityName = val.name;
      this.showPickerCityname = false;
    },
    //类型 教室，个人
    onConfirmType(val) {
      this.typeName = val.name;
      this.ruleForm.type = val.type;
      this.showPickerType = false;
      this.$refs.type.style.display = "none";
    },
    //在用者
    onConfirmWorker() {
      if (this.ruleForm.worker) {
        let currentWorker = JSON.parse(this.ruleForm.worker);
        this.ruleForm.idCard = "QF" + currentWorker.jobNo;
        this.ruleForm.currentWorker = currentWorker.realname + "-QF" + currentWorker.jobNo;
        this.ruleForm.workerId = currentWorker.id;
      } else {
        this.ruleForm.idCard = "";
        this.ruleForm.currentWorker = "";
        this.ruleForm.workerId = "";
      }
      this.showPickerWorker = false;
      console.log(this.ruleForm.workerId);
      this.$refs.currentName.style.display = "none";
    },

    //校区下教室
    async onConfirmRooms() {
      if (this.currentRoom) {
        let currentRoom = JSON.parse(this.currentRoom);
        this.ruleForm.classRoom = currentRoom.name;
        this.ruleForm.classRoomId = currentRoom.id;
        const { data: resData } = await roomStudent({
          roomId: currentRoom.id,
        });
        if (resData.code !== 200) return Toast.fail(resData.msg);
        this.roomStudentList = resData.data;
        this.remarkStudentList = resData.data;
        this.$refs.currentRoom.style.display = "none";
      } else {
        this.ruleForm.classRoom = "";
        this.ruleForm.classRoomId = "";
      }
      this.showPickerRoom = false;
    },

    //教室学生
    async onConfirmStudent() {
      if (this.studentName) {
        let currentStudent = JSON.parse(this.studentName);
        this.ruleForm.studentId = currentStudent.stuid;
        this.currentStudent = currentStudent.stuname;
        this.$refs.student.style.display = "none";
      } else {
        this.ruleForm.studentId = "";
        this.currentStudent = "";
      }
      this.showPickerStudent = false;
    },

    //提交出库
    async submitOut() {
      if (this.barCode === "") {
        return (this.$refs.barCode.style.display = "block");
      }
      if (this.machshineInfoTr.length < 5) {
        return (this.$refs.machshine.style.display = "block");
      }
      if (!this.ruleForm.type) {
        return (this.$refs.type.style.display = "block");
      }
      if (this.ruleForm.type === "1") {
        if (this.ruleForm.workerId === "") {
          return (this.$refs.currentName.style.display = "block");
        }
      }
      if (this.ruleForm.type === "2") {
        if (this.ruleForm.classRoomId === "") {
          return (this.$refs.currentRoom.style.display = "block");
        }
        if (this.ruleForm.studentId === "") {
          return (this.$refs.student.style.display = "block");
        }
      }

      const { data: res } = await assetsOut({
        assetsNos: [this.barCode],
        cityId: this.ruleForm.cityId,
        currentId: this.ruleForm.type === "1" ? this.ruleForm.workerId : this.ruleForm.classRoomId,
        idCard: this.ruleForm.type === "1" ? this.ruleForm.idCard : "",
        remark: this.ruleForm.remark,
        stuId: this.ruleForm.type === "2" ? this.ruleForm.studentId : "",
        type: this.ruleForm.type,
      });
      if (res.code != 200) return Toast.fail(res.msg);
      this.barCode = "";
      Toast.success("资产出库成功");
    },
    backToPre() {
      this.$router.go(-1);
    },
    replyConfig() {
      wxConfig(window.location.href.split("#")[0], ["scanQRCode"]);
    },
    scanCode() {
      let that = this;
      wx.scanQRCode({
        desc: "scanQRCode desc",
        needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是条形码（一维码），默认二者都有
        success: function (res) {
          // 回调
          that.barCode = res.resultStr; //当needResult为1时返回处理结果
        },
        error: function (res) {
          if (res.errMsg.indexOf("function_not_exist") > 0) {
            alert("版本过低请升级");
          }
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.admininOut {
  min-height: 100vh;
  padding: 19px 28px 0;
  background-color: #ffffff;
  .form_item {
    margin-bottom: 30px;
    &.flex_item {
      display: flex;
      align-items: center;
    }
    .label_item {
      font-size: 28px;
      color: #666666;
      margin-bottom: 16px;
    }
    .codeNum {
      position: relative;
      width: 100%;
      border: 1px solid #d8d8d8;
      padding: 20px 50px 20px 20px;
      input {
        font-size: 26px;
        outline: none;
        width: 90%;
      }
      .scanIMG {
        width: 40px;
        position: absolute;
        right: 20px;
        top: 16px;
      }
    }
    dl {
      line-height: 78px;
      height: 78px;
      background-color: #f5f5f5;
      border-radius: 6px;
      width: 100%;
      color: #333333;
      font-size: 26px;
      padding: 0 20px;
    }
    .textarea_remark {
      padding: 20px;
      background-color: #ffffff;
      border-radius: 6px;
      border: 1px solid #d8d8d8;
    }
    textarea {
      resize: none;
      width: 100%;
      font-size: 26px;
      outline: none;
      border: none;
    }
    span {
      font-size: 28px;
      color: #666666;
      width: 180px;
    }
    .flex-right-input {
      flex: 1;
      position: relative;
      border: 1px solid #d8d8d8;
      border-radius: 6px;
      input {
        font-size: 26px;
        padding: 19px 12px 19px 20px;
        width: 100%;
      }
      .van-icon-arrow-down {
        position: absolute;
        right: 16px;
        top: 22px;
        color: #b6b6b6;
      }
    }
  }
  .error_text {
    font-size: 24px;
    color: #f56c6c;
    margin: -25px 0 8px 0;
    display: none;
  }
  .button_group {
    text-align: center;
    .van-button {
      width: 150px;
      font-size: 16px;
      border-radius: 8px;
      &:first-child {
        background-color: #f5f5f5;
        margin-right: 39px;
        color: #333333;
      }
      &:last-child {
        background-color: #277fff;
        color: #ffffff;
      }
    }
  }
  .select_border {
    background-color: #ffffff;
    position: relative;
    header {
      padding: 0 30px;
      font-size: 32px;
      line-height: 88px;
      display: flex;
      justify-content: space-between;
      background-color: #f1f1f1;
      span {
        &:first-child {
          color: #666666;
        }
        &:last-child {
          color: #277fff;
        }
      }
    }
    .flex-center {
      display: flex;
      padding-right: 30px;
      margin-bottom: -8px;
      .van-search {
        /deep/ .van-icon-search {
          font-size: 30px;
        }

        /deep/ .van-field__control {
          font-size: 28px;
        }
      }
    }
    .van-search__content {
      height: 80px;
      padding-left: 30px;
      border-radius: 40px;
      background-color: #f3f3f3;
    }
    .van-search .van-cell {
      align-items: center;
    }
    .van-field__left-icon {
      height: 80px;
    }
    .van-radio-group {
      padding: 0 30px 20px;
      overflow-y: auto;
      height: 380px;
      //margin-top: -5px;
      &.specialRadio {
        height: 495px;
      }
      [class*="van-hairline"]::after {
        border: none;
      }
      .van-cell-group {
        .van-cell {
          padding: 24px 0;
          border-bottom: 0.5px solid #dedede;
          &:last-child {
            border-bottom: none;
          }
          &::after {
            border-bottom: none;
          }
        }
        .flex-user {
          font-size: 28px;
          color: #333333;
          text-indent: 6px;
        }
        /deep/.van-radio__icon {
          font-size: 32px;
          margin-right: 12px;
          .van-icon {
            width: 32px;
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
